/**
 * KAN-828: права текущего пользователя на менеджера клиента (одно правило
 * clientManagerRights для блока внимания, строки CRM и карточки клиента).
 */
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { clientManagerRights, type ClientManagerRights } from '@/lib/clientManagerRights';

export function useClientManagerRights(currentManagerId: string | null | undefined): ClientManagerRights {
  const { data: user } = useCurrentUser();
  return clientManagerRights(user, currentManagerId);
}
